export default "__VITE_ASSET__mPH_Fegu__"